import { useMemo } from 'react';
import { prepareAndGetColorsForPieChart } from '../../../prompt/preview/components/stats/helpers/StatsHelper';
import { PieChartData } from '../../../../shared/models/common/PieChartData';

export const useChartColors = (
  shareOfVoiceData: PieChartData[],
  firmName: string,
  keywordsMap: Map<string, string>
) =>
  useMemo(() => {
    if (!shareOfVoiceData || !keywordsMap || keywordsMap.size === 0) {
      return null;
    }

    return prepareAndGetColorsForPieChart(shareOfVoiceData, firmName);
  }, [shareOfVoiceData, firmName, keywordsMap]);
